module.exports = __webpack_public_path__ + "static/media/fresh-factory-ad1.87e06f90.png";